import { Button } from "components/DesignSystem/Button/Button";
import { useModal } from "hooks/useModal";
import React from "react";
import { AIAgentValidation } from "types/Models/reviewDocumentAndBalancingPayment";
import { ThreadManualAnalysis } from "./ThreadManualAnalysis";
import { GreentickGreenCircle } from "components/icons/GreentickGreenCircle";

export const ThreadManualAnalysisTrigger = ({
  aiAgentValidation,
  channelId,
  messageId,
}: {
  aiAgentValidation?: AIAgentValidation;
  channelId?: string;
  messageId?: string;
}) => {
  const threadManualAnalysisModal = useModal();
  const hasAdminFeedback = Boolean(aiAgentValidation?.thread_feedback_rating);

  return (
    <>
      {hasAdminFeedback ? (
        <div className="t-p-2.5 t-rounded-lg t-bg-green-10 t-border t-border-solid t-border-green-20 t-flex t-mx-4 t-items-center t-gap-2">
          <div className="t-flex-1 t-text-wrap t-flex t-align-top t-gap-2">
            <GreentickGreenCircle className="t-text-green-80" />
            <span className="t-text-text-60 t-text-body-sm">
              A feedback has been recorded for this thread.
            </span>
          </div>
          <Button size="small" onClick={threadManualAnalysisModal.open}>
            View
          </Button>
        </div>
      ) : (
        <div className="t-p-2.5 t-rounded-lg t-bg-purple-0 t-border t-border-solid t-border-purple-20 t-flex t-mx-4 t-items-center t-gap-2">
          <div className="t-flex-1 t-text-wrap t-text-text-60 t-text-body-sm t-flex">
            Review this AI thread for quality check
          </div>
          <Button size="small" onClick={threadManualAnalysisModal.open}>
            Give feedback
          </Button>
        </div>
      )}
      {threadManualAnalysisModal.isOpen && channelId && messageId && (
        <ThreadManualAnalysis
          {...threadManualAnalysisModal}
          channelId={channelId}
          messageId={messageId}
          aiAgentValidation={aiAgentValidation}
        />
      )}
    </>
  );
};
